<ng-container *transloco="let t; prefix:'tasks.taskDetail'">
  <div class="sommario-stato-wrapper">
    <div class="sommario">
      <div class="sommario-top">
        <div class="sommario-top-one">
          <span class="body-small">{{ (task?.dataTask | date: 'dd/MM/yyyy | HH:mm' : 'UTC') || '-' }} </span>
          <div class="sommario-inline">
            <span class="body-small text-on-surface">{{t("sentFrom")}}</span> <span class="title-medium">{{task?.dettaglio.requestedBy}}</span>
          </div>
          <span class="body-medium">{{ task?.importo | translocoCurrency: 'symbol' : {useGrouping: true} ?? '-' }}</span>
        </div>
      
        <div class="sommario-top-two">
          <span class="title-medium">{{ task?.titolo ?? '-' }}</span>

          <!--TODO: Bindare e gestire piu tipi di dettaglio -->
          <span class="body-small text-on-surface">{{ task?.nome ?? '-' }}</span>
        </div>
      </div>

      <div class="sommario-bottom">
        <span class="body-medium text-on-surface">{{ task?.descrizione ?? '-' }}</span>
      </div>

      <!--TODO: Come funziona?? Entro quanti caratteri si attiva?-->
      <!-- <button mat-button>
        <span>Leggi di più</span>
        <i class="fa-regular fa-circle-arrow-down"></i>
      </button> -->
    </div>

    <mat-card class="stato">
      <mat-card-header>
          <mat-card-title>
            {{t("status")}}
          </mat-card-title>
      </mat-card-header>

      <mat-card-content>
        @if(this.task) {
          <mat-stepper
            class="stepper"
            [orientation]="orientation"
            [linear]="false"
            [selectedIndex]="selectedStepperIndex"
          >
            <ng-template matStepperIcon="number" let-index="index">
              @if (isRejectedStepperIndex(index)) {
                <mat-icon class="stepper-rejected-icon">close</mat-icon>
              } @else {
                <mat-icon [class.stepper-approved-icon]="isApprovedStepperIndex(index)">done</mat-icon>
              }
            </ng-template>

            <ng-template matStepperIcon="done">
                <mat-icon>done</mat-icon>
            </ng-template>

            <!-- Default step -->
            <mat-step
              [label]="'Inserimento ordine'"
              [editable]="false"
              [completed]="true"
            ></mat-step>

            <!-- Other steps -->
            @for (step of totalRoles; let i = $index; track i) {
              <mat-step
                  [label]="step.name"
                  [editable]="false"
                  [completed]="i <= currentStepperIndex"
              ></mat-step>
            }
          </mat-stepper>
        }
        @if (lastApprovedOrRefusedRole; as lastRole) { <!-- alias per "ricreare" l'oggetto ultimo ruolo -->
          <div class="stato-info">
            <div class="stato-info-left">
              <span class="body-small text-on-surface">
                {{ (lastRole.outcome?.trim()?.toLowerCase() === 'approved') ? t("approved") : t("refused") }}
              </span>
              <span class="body-medium">{{ lastRole.descrizioneApprovatore ?? '-' }}</span>
            </div>

            <span class="label-small stato-info-date">
              {{ (lastRole.dataApprovazione | date: 'dd/MM/yyyy | HH:mm') || '-' }}
            </span>
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>

  <br>

  @if(this.currentUserCanEdit) {
  <mat-card class="approvazione">
      <mat-card-header>
          <mat-card-title>{{t('approveTask.title')}}</mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div>
          <button
            mat-button
            type="button"
            [matMenuTriggerFor]="menu"
            #trigger="matMenuTrigger"
          >
            <div class="priority-selection-buttons">
              <span class="priority-dot" [ngClass]="priorityDotClass(selectedPriority.value)"></span>
              <span class="label-medium priority-text">{{ selectedPriority.label }}</span>
              <i [attr.class]="trigger.menuOpen ? 'fa-regular fa-chevron-down priority-chevron' : 'fa-regular fa-chevron-right priority-chevron'"></i>
            </div>
          </button>
        
          <mat-menu #menu="matMenu">
            @for (p of priorities; track p.value) {
              <button mat-menu-item (click)="selectPriority(p)">
                <div class="priority-selection-buttons">
                  <span class="priority-dot" [ngClass]="priorityDotClass(p.value)"></span>
                  <span class="label-medium priority-text">{{ p.label }}</span>
                  @if (p.value === selectedPriority.value) {
                    <i class="fa-regular fa-check priority-check"></i>
                  }
                </div>
              </button>
            }
          </mat-menu>
        </div><br>

        <div class="approvazione-wrapper">
          <div class="approvazione-commento">
            <textarea
              id="approve-task-comment"
              class="approvazione-textarea body-medium"
              [placeholder]="t('approveTask.comment')"
              rows="4"
              [(ngModel)]="comment"
            ></textarea>
          </div>

          <div class="approvazione-upload-block">
            <div class="approvazione-upload"
              [class.approvazione-upload--hover]="isDragOver"
              (dragover)="onDragOver($event)"
              (dragleave)="onDragLeave($event)"
              (drop)="onDrop($event)"
            >
              <div class="approvazione-upload-empty">
                <div class="approvazione-upload-inner">
                  <i class="fa-regular fa-file-arrow-down approvazione-upload-icon"></i>
                
                  <!-- Desktop-only: testo come screenshot -->
                  <span class="body-medium approvazione-upload-desktop-text">{{t('approveTask.dragHere')}}</span>
                  <span class="label-small approvazione-upload-desktop-or">{{t('approveTask.dragHereOr')}}</span>
                
                  <button
                    matButton="filled"
                    color="primary"
                    (click)="fileInput.click()"
                  >
                    {{ isMobile ? t('approveTask.uploadBtnMobile') : t('approveTask.uploadBtn') }}
                  </button>
                </div>
              </div>
            
              <input
                #fileInput
                type="file"
                multiple
                class="approvazione-upload-input"
                (change)="onFileSelected($event)"
              />
            </div>

            @if (files.length > 0) {
              <div class="approvazione-upload-file-list">
                @for (f of files; track f; let i = $index) {
                  <div class="file-card">
                    <div class="file-card-icon">
                      <i class="fa-regular fa-file-pdf"></i>
                    </div>
                  
                    <span class="file-card-name label-medium">{{ f.name }}</span>
                  
                    <button
                      type="button"
                      class="file-card-button"
                      (click)="removeFile(i)"
                      aria-label="Rimuovi file"
                    >
                      <i class="fa-regular fa-trash-can"></i>
                    </button>
                  </div>
                }
              </div>
            }      
          </div>
        </div>

        <!-- TODO: AGGIUNGERE LOGICA DISABLED SE MANCANO FILE E/O COMMENTO -->
        <div class="approvazione-actions">
            <button
              [disabled]="!currentUserCanEdit"
              matButton="outlined"
              (click)="onTaskApprovalManagement(false)"
            >{{t('approveTask.rejectBtn')}}</button>

            <button
              [disabled]="!currentUserCanEdit"
              matButton="filled"
              (click)="onTaskApprovalManagement(true)"
            >{{t('approveTask.approveBtn')}}</button>
        </div>
      </mat-card-content>    
  </mat-card>

  <br>
  }

  @if(checkForShowStoricSection()) {
    <div class="storico">
        <span class="title-large storico-title">{{t('taskHistory')}}</span>

        @for (item of reversedRolesList; let i = $index; track i) {
          @if(item.outcome && item.outcome != '') {
            <mat-card class="storico-item">         
              <div class="storico-secondary-info">
                <ui-priority-status class="storico-priority" [priority]="item.priorita"></ui-priority-status>

                <div class="storico-date">
                  @if(isMobile){
                    <span class="label-small">{{ (item.dataApprovazione | date: 'dd/MM/yyyy | HH:mm') || '-' }}</span>
                  }
                  @else{
                    <span class="label-small">{{ (item.dataApprovazione | date: 'dd/MM/yyyy') || '-' }}</span>
                    <span class="label-small">{{ (item.dataApprovazione | date: 'HH:mm') || '-' }}</span>
                  }
                </div>
              </div>

              <div class="avatar-frame">
                <img src="assets/user.jpg" alt="Profilo" class="profile-image"/>
              </div>

              <div class="storico-main-info">
                <span class="title-medium">{{ item.descrizioneApprovatore }}</span>
                <span
                  class="body-small storico-desc-text"
                  [class.storico-desc-text--clamp]="isMobile && !isExpanded(i)"
                >
                  {{ item.notes }}
                </span>

                @if (isMobile && isLongText(item.notes)) {
                  <button
                    type="button"
                    mat-button
                    class="storico-readmore"
                    (click)="toggleStorico(i)"
                  >
                    <span>{{ isExpanded(i) ? t('readLess') : t('readMore') }}</span>
                    <i class="fa-regular fa-circle-arrow-down"></i>
                  </button>
                }
              </div>

              <div class="storico-attachments">
                @for (allegato of item.allegati; track $index) {
                  <div class="file-card">
                    <div class="file-card-icon">
                      <i class="fa-regular fa-file"></i>
                    </div>

                    <span class="file-card-name label-medium">{{ getAllegatoFileName(allegato.filePath) }}</span>

                    <button
                      type="button"
                      class="file-card-button"
                      (click)="downloadAttachment(allegato)"
                    >
                      <i class="fa-regular fa-download"></i>
                    </button>
                  </div>
                }
              </div>
            </mat-card>
          }
        }
    </div>
  }

  <div class="prop">
    <span class="title-large prop-title">{{t('taskProp.title')}}</span>

    <mat-card class="prop-block-first">
      <mat-card-content>
        <div class="prop-field">
          <p class="title-small prop-field-first">{{t('taskProp.expired')}}</p>
          <p class="body-medium prop-field-first">{{ task?.dettaglio?.customerOverdueAmount | translocoCurrency: 'symbol' : {useGrouping: true} ?? '-' }}</p>
        </div>

        <div class="prop-field">
          <p class="title-small prop-field-first">{{t('taskProp.creditLimit')}}</p>
          <p class="body-medium prop-field-first">
            {{
              toNumber(task?.dettaglio?.customerCreditLimitExceeded)
                | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 }
            }}
          </p>
        </div>
      
        <div class="prop-field">
          <p class="title-small prop-field-first">{{t('taskProp.value')}}</p>
          <p class="body-medium prop-field-first">{{ task?.dettaglio?.orderTotalAmount | translocoCurrency: 'symbol' : {useGrouping: true} ?? '-' }}</p>
        </div>
      
        <div class="prop-field">
          <p class="title-small prop-field-first">{{t('taskProp.creditSystem')}}</p>
          <p class="body-medium prop-field-first">
            {{ task?.dettaglio?.systemGrantedCreditLimit | translocoCurrency: 'symbol' : {useGrouping: true} ?? '-' }}
          </p>
        </div>
      
        <div class="prop-field">
          <p class="title-small prop-field-first">{{t('taskProp.creditData')}}</p>
          <p class="body-medium prop-field-first">
            {{ 
              task?.dettaglio?.customerReliability ? 
              (
                task?.dettaglio?.customerReliability | translocoCurrency: 'symbol' : 
                {
                  useGrouping: true,
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }
              ) : 
              '-'  
            }}  
          </p>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="prop-block-second">
      <mat-card-content>
        <div class="prop-field">
          <p class="title-small">{{t('taskProp.customerStatus')}}</p>
          <p class="body-medium">{{ task?.dettaglio?.customerStatus || '-' }}</p>
        </div>
      
        <div class="prop-field">
          <p class="title-small">{{t('taskProp.customerType')}}</p>
          <p class="body-medium">{{ task?.dettaglio?.customerType ?? '-'  }}</p>
        </div>
      
        <div class="prop-field">
          <p class="title-small">{{t('taskProp.family')}}</p>
          <p class="body-medium">{{ task?.dettaglio?.productFamily ?? '-'  }}</p>
        </div>
      
        <div class="prop-field">
          <p class="title-small">{{t('taskProp.margin')}}</p>
          <p class="body-medium">{{ task?.dettaglio?.orderMagin ?? '-'  }}</p>
        </div>

        @if (showExtraProps) {
          <hr class="prop-divider" />

          <div class="prop-field">
            <p class="title-small">{{t('taskProp.creditCommittee')}}</p>
            <p class="body-medium">
              {{ 
                task?.dettaglio?.committeeApprovedCreditLimit ? 
                (
                  task?.dettaglio?.committeeApprovedCreditLimit | translocoCurrency: 'symbol' : 
                  {
                    useGrouping: true,
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }
                ) : 
                '-'  
              }}
            </p>
          </div>
        
          <!-- TODO: QUANDO CI SARANNO I CAMPI EDITABILI, AGGIORNARE LA LOGICA DEL TASK SECURITY MASK PREVEDENDO READ E WRITE INSIEME -->
          @if(task?.taskSecurityMask?.canReadProcuratorUnitMarginOnOrder){
            <div class="prop-field">
              <p class="title-small">{{t('taskProp.aumOrder')}}</p>
              <p class="body-medium">{{ task?.dettaglio?.procuratorUnitMarginOnOrder ?? '-'  }}</p>
            </div>
          } 
        
          @if(task?.taskSecurityMask?.canReadManagerUnitMarginOnOrder){
            <div class="prop-field">
              <p class="title-small">{{t('taskProp.mumOrder')}}</p>
              <p class="body-medium">{{ task?.dettaglio?.managerUnitMarginOnOrder ?? '-'  }}</p>
            </div>
          }
        
          @if(task?.taskSecurityMask?.canReadProcuratorUnitMarginOnCustomer){
            <div class="prop-field">
              <p class="title-small">{{t('taskProp.aumCustomer')}}</p>
              <p class="body-medium">{{ task?.dettaglio?.procuratorUnitMarginOnCustomer ?? '-'  }}</p>
            </div>
          }
        
          @if(task?.taskSecurityMask?.canReadManagerUnitMarginOnCustomer){
            <div class="prop-field">
              <p class="title-small">{{t('taskProp.mumCustomer')}}</p>
              <p class="body-medium">{{ task?.dettaglio?.managerUnitMarginOnCustomer ?? '-'  }}</p>
            </div>
          }
        
          <div class="prop-field">
            <p class="title-small">{{t('taskProp.managerEvMargin')}}</p>
            <p class="body-medium">{{ task?.dettaglio?.managerEvaluatedMargin ?? '-'  }}</p>
          </div>
        }

        <div class="prop-toggle">
          <button
            type="button"
            mat-button
            (click)="toggleExtraProps()"
            class="prop-toggle-btn"
          >
            <span class="label-medium">
              {{ showExtraProps ? t('taskProp.showLess') : t('taskProp.showAll') }}
            </span>
          
            <i
              [attr.class]="showExtraProps ? 'fa-regular fa-chevron-up prop-toggle-icon' : 'fa-regular fa-chevron-down prop-toggle-icon'"
            ></i>
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</ng-container>

 <!-- SEZIONE PRODOTTI -->
<mat-card class="prodotti">
  <mat-card-header>
    <mat-card-title>Prodotti in commessa</mat-card-title>
  </mat-card-header>
</mat-card>


<div class="prodotti-list-wrapper">
  @if (isMobile) {
    <div class="prodotti-mobile">
      @for (item of products; track item.codiceProdotto) {
        <mat-card
          class="prodotti-card"
          (click)="openProductDetail(item)">
          <div class="prodotti-card-header">
            <div class="prodotti-name title-medium">
              {{ item.descrizioneProdotto }} ({{ item.pProvvigione }})
            </div>

            <mat-icon class="chevron">chevron_right</mat-icon>
          </div>
        </mat-card>
      }
    </div>
  } @else {
    <ui-table-view
      class="table-view"
      [columnsInfo]="columnsInfo"
      [data]="products">
    </ui-table-view>
  }
</div>

<!-- POPUP DETTAGLIO -->
@if (isMobile && selectedProduct) {
  <div class="prodotti-popup">
    <div class="prodotti-popup-header">
      <button
        mat-icon-button
        (click)="closeProductDetail()"
        aria-label="Chiudi dettaglio prodotto">
        <mat-icon>close</mat-icon>
      </button>
    
      <div class="prodotti-popup-title title-medium">
        {{ selectedProduct.descrizioneProdotto }} ({{ selectedProduct.pProvvigione }})
      </div>
    </div>
  
    <!-- DETTAGLI -->
    <div class="prodotti-popup-body">
      <div class="prodotti-popup-row">
        <span class="title-small">Codice Prodotto</span><br>
        <span class="body-medium black">{{ selectedProduct.codiceProdotto }}</span>
      </div>
    
      <div class="prodotti-popup-row">
        <span class="title-small">Codice Imballo</span><br>
        <span class="body-medium black">{{ selectedProduct.codiceImballo }}</span>
      </div>

      <div class="prodotti-popup-row">
        <span class="title-small">Qtà Imballi</span><br>
        <span class="body-medium black">{{ selectedProduct.qtaImballi | translocoDecimal : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } }}</span>
      </div>

      <div class="prodotti-popup-row">
        <span class="title-small">Prezzo</span><br>
        <span class="body-medium black">
          {{ 
            selectedProduct.prezzo | translocoCurrency: 'symbol' : 
              {
                useGrouping: true,
                minimumFractionDigits: 4,
                maximumFractionDigits: 4
              } 
          }}
        </span>
      </div>

      <div class="prodotti-popup-row">
        <span class="title-small">Qtà Fatturabile</span><br>
        <span class="body-medium black">{{ selectedProduct.qtaFatturabile | translocoDecimal : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } }}</span>
      </div>

      <div class="prodotti-popup-row">
        <span class="title-small">% Provvigione</span><br>
        <span class="body-medium black">{{ selectedProduct.pProvvigione }}</span>
      </div>

      <div class="prodotti-popup-row">
        <span class="title-small">% No Profit</span><br>
        <span class="body-medium black">{{ selectedProduct.pNoProfit }}</span>
      </div>

      <div class="prodotti-popup-row">
        <span class="title-small">% Fuori Premio</span><br>
        <span class="body-medium black">{{ selectedProduct.pFuoriPremio }}</span>
      </div>

      <div class="prodotti-popup-row">
        <span class="title-small">Data Ultimo Acquisto</span><br>
        <span class="body-medium black">{{ selectedProduct.dataUltimoAcquisto }}</span>
      </div>

      <div class="prodotti-popup-row">
        <span class="title-small">Prezzo Ultimo Acquisto</span><br>
        <span class="body-medium black">
          {{ 
            selectedProduct.prezzoUltimoAcquisto | translocoCurrency: 'symbol' : 
              {
                useGrouping: true,
                minimumFractionDigits: 4,
                maximumFractionDigits: 4
              } 
          }}
        </span>
      </div>
    </div>
  </div>
}
